import React from 'react';
import dcgLogo from '../../../assets/img/brand/dcg_logo_header.png';
import { HeaderAndBodyLayout } from '../../../utilities/dcgAutomationPageCommonImports';
import TraditionalDeviceConfirmationPageContent from '../PageContent/TraditionalDeviceConfirmationPageContent';


const TraditionalDeviceConfirmation = () => {
    return (
        <HeaderAndBodyLayout headerLogo={dcgLogo} containerSize="md" backButton={false}>
            <TraditionalDeviceConfirmationPageContent />
        </HeaderAndBodyLayout>
    );
};

export default TraditionalDeviceConfirmation;

